const CustomsResult = {
  keyFields: ['customsEntryId']
};

export default CustomsResult;
